<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "wallet" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start align-items-center mb-1" },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between w-100 refresh-button-container",
            },
            [
              _c("div", [_c("h3", [_vm._v(_vm._s(_vm.$t("wallet.Wallet")))])]),
              _c(
                "div",
                { staticClass: "refresh-button" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-icon",
                      attrs: { variant: "flat-primary" },
                      on: { click: _vm.refresh },
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "RotateCwIcon" } }),
                      _c("span", { staticClass: "align-middle ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("wallet.Refresh"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "border" }, [
        _c(
          "div",
          { staticClass: "pad-l-r-15" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "p-0", attrs: { lg: "7" } },
                  [
                    _c("b-card", { staticClass: "mb-0 estimated-balance" }, [
                      _c("p", { staticClass: "h4" }, [
                        _vm._v(_vm._s(_vm.$t("wallet.EstimatedBalance"))),
                      ]),
                      _c("p", { staticClass: "content1" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.totalBalance + " " + _vm.totalBalanceCurrency
                            ) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "amt mb-0" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("wallet.≈") +
                                " " +
                                _vm.totalFiatBalance +
                                " " +
                                _vm.totalFiatBalanceCurrency
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c("b-col", { staticClass: "pr-0", attrs: { lg: "5" } }, [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mb-1 mobile-w" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-1 mr-1 s-rt",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openPage({
                                    path: "deposit",
                                    params: { lang: _vm.lang || undefined },
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("wallet.Deposit")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-1 mr-1 s-rt",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openPage({
                                    path: "withdraw",
                                    params: { lang: _vm.lang || undefined },
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("wallet.Withdraw")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "mt-1 mr-1",
                          attrs: { variant: "secondary " },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                path: "transactionHistory",
                                params: { lang: _vm.lang || undefined },
                              })
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("wallet.Transactions")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("b-col", { staticClass: "pl-0 pr-0", attrs: { lg: "2", md: "2" } }, [
        _c(
          "div",
          { staticClass: "mb-1" },
          [
            _c("b-form-input", {
              attrs: { placeholder: _vm.$t("wallet.SearchCoinNetwork") },
              model: {
                value: _vm.searchText,
                callback: function ($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _c("b-table", {
            staticClass: "tr-cal",
            attrs: {
              items: _vm.items,
              fields: _vm.fields,
              responsive: "",
              "show-empty": "",
              striped: "",
              "sort-desc": _vm.sortDesc,
              "sort-by": _vm.sortBy,
            },
            on: {
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "head()",
                fn: function (ref) {
                  var label = ref.label
                  var ref_field = ref.field
                  var key = ref_field.key
                  var sortable = ref_field.sortable
                  return [
                    _vm._v(" " + _vm._s(label) + " "),
                    sortable
                      ? [
                          [
                            _vm.sortBy !== key
                              ? _c("Updown1", { staticClass: "svg-updown" })
                              : _vm.sortDesc
                              ? _c("Updown2")
                              : _c("Updown3"),
                          ],
                        ]
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(asset)",
                fn: function (data) {
                  return [
                    _c("b-img", {
                      staticClass: "align-middle mr-0 currency-image-height",
                      attrs: { src: data.item.assetImgUrl, size: "4" },
                    }),
                    _c("span", { staticClass: "ml-1" }, [
                      _vm._v(_vm._s(data.value)),
                    ]),
                  ]
                },
              },
              {
                key: "cell(totalBalance)",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(data.value) + " ")]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      { staticClass: "mr-2" },
                      [
                        _c(
                          "b-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openPage({
                                  name: "deposit",
                                  params: { lang: _vm.lang || undefined },
                                  query: {
                                    coin: data.item.asset,
                                    network: data.item.network,
                                  },
                                })
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("wallet.Deposit")) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      [
                        _c(
                          "b-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openPage({
                                  name: "withdraw",
                                  params: { lang: _vm.lang || undefined },
                                  query: {
                                    coin: data.item.asset,
                                    network: data.item.network,
                                  },
                                })
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("wallet.Withdraw")))]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center justify-content-sm-end",
                  attrs: { cols: "12", sm: "12" },
                },
                [
                  _vm.isPaginationVisible
                    ? _c("b-pagination", {
                        key: _vm.page,
                        staticClass: "mb-0 mt-1 mt-sm-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.size,
                          "first-number": "",
                          "last-number": "",
                          "prev-class": "prev-item",
                          "next-class": "next-item",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prev-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronLeftIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "next-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronRightIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1308952388
                        ),
                        model: {
                          value: _vm.page,
                          callback: function ($$v) {
                            _vm.page = $$v
                          },
                          expression: "page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("KycNotComplete", {
        attrs: {
          showPop: _vm.warningPop,
          onModalHidden: _vm.onModalHidden,
          msg: _vm.warningMsg,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/wallet/Wallet.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_QRcode_svg from '@/assets/rashi-coin/QRcode.svg';
import assets_rashi_coin_down1_svg from '@/assets/rashi-coin/down1.svg';
import assets_rashi_coin_down2_svg from '@/assets/rashi-coin/down2.svg';
import assets_rashi_coin_down3_svg from '@/assets/rashi-coin/down3.svg';
import assets_rashi_coin_tb_usdt_svg from '@/assets/rashi-coin/tb-usdt.svg';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import utils_constants from '@/utils/constants';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    Updown1: assets_rashi_coin_down1_svg,
    Updown2: assets_rashi_coin_down2_svg,
    Updown3: assets_rashi_coin_down3_svg,
    QRcode: assets_rashi_coin_QRcode_svg,
    copy: assets_rashi_coin_copy_svg,
    BImg: bootstrapvue["BImg"],
    BRow: bootstrapvue["BRow"],
    USDT: assets_rashi_coin_tb_usdt_svg,
    BCol: bootstrapvue["BCol"],
    BContainer: bootstrapvue["BContainer"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BAvatar: bootstrapvue["BAvatar"],
    BBadge: bootstrapvue["BBadge"],
    vSelect: vue_select,
    BFormInput: bootstrapvue["BFormInput"],
    BDropdown: bootstrapvue["BDropdown"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupText: bootstrapvue["BInputGroupText"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BPagination: bootstrapvue["BPagination"],
    KycNotComplete: layouts_components_KycNotComplete_vue
  },
  data() {
    return {
      sortBy: null,
      sortDesc: false,
      searchText: "",
      order: true,
      field: "availableBalance",
      totalAssetBalance: 0,
      fields: [{
        key: "asset",
        label: this.$t("wallet.Coin"),
        sortable: true,
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalBalance",
        label: this.$t("wallet.Total")
      }, {
        key: "availableBalance",
        label: this.$t("wallet.Available"),
        sortable: true
      }, {
        key: "actions",
        label: this.$t("wallet.Action"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }],
      items: [],
      firstTime: true,
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isPaginationVisible: false,
      totalRows: 0,
      totalBalance: 0,
      totalFiatBalance: 0,
      totalBalanceCurrency: "",
      totalFiatBalanceCurrency: "",
      warningPop: false,
      warningMsg: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user"])
  },
  mounted() {
    let flag = 0;
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page;
      flag++;
    }
    if (this.$route && this.$route.query && this.$route.query.searchText && this.searchText !== this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
    }
    if (!flag) {
      this.getAllWallets();
    }
    this.getTotalAssetBalance();
    setTimeout(() => {
      this.firstTime = false;
    }, 5 * 1000);
  },
  watch: {
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAllWallets();
    },
    page() {
      utils_constants["setPagination"].apply(this, [`${this.page}`]);
      this.getAllWallets();
    },
    searchText(newVal) {
      let obj = {
        searchText: newVal
      };
      utils_constants["setQueryParams"].apply(this, [obj]);
      this.search();
    },
    sortBy(newVal) {
      if (newVal && this.field != newVal) {
        this.order = this.sortDesc;
        this.field = this.sortBy;
        this.search(100);
      }
    },
    sortDesc(newVal) {
      if (this.order != newVal) {
        this.order = this.sortDesc;
        this.field = this.sortBy;
        this.search(100);
      }
    }
  },
  methods: {
    onModalHidden(props) {
      this.warningPop = props;
    },
    openPage(props) {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteForWallet", {
          type: props.name === "withdraw" ? this.$t("wallet.withdraw") : this.$t("wallet.deposit")
        });
        return;
      }
      this.$router.push(props);
    },
    refresh() {
      this.getAllWallets();
      this.getTotalAssetBalance();
    },
    search(time) {
      const debounceTime = time || 500;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        if (this.firstTime || this.page == 1) {
          this.getAllWallets();
        }
        if (!this.firstTime) {
          this.page = 1;
        }
      }, debounceTime);
    },
    async getAllWallets() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `asset/search`
        }, {
          isHideZeroBalance: false,
          searchText: this.searchText || undefined,
          page: this.page,
          size: this.size,
          "sort.field": this.field,
          "sort.order": this.order ? "desc" : "asc"
        }, {
          isLoading: true
        });
        if (res && res.assets) {
          this.items = res.assets;
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getTotalAssetBalance() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `asset/totalBalance`
        }, {}, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.totalBalance = res.totalBalance;
          this.totalFiatBalance = res.totalFiatBalance;
          this.totalBalanceCurrency = res.totalBalanceCurrency;
          this.totalFiatBalanceCurrency = res.totalFiatBalanceCurrency;
          this.totalAssetBalance = res.totalAssetBalance;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/wallet/Wallet.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.content1 {
  color: #8dc540;
  font-size: 34px;
  font-weight: 600;
  line-height: 40px;
}
.h4 {
  color: var(--text-black-color);
  font-size: 21px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 1.47px;
}
[dir] .h4 {
  margin: 0px 0px 16px 0px;
}
[dir] .wallet .border {
  margin-bottom: 15px;
}
.amt {
  color: var(--text-black-color);
  font-size: 19px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1.33px;
}
.Search {
  color: #6e6b7b;
  font-size: 16px;
  font-weight: 400;
}
.text-lable {
  color: var(--text-black-color);
  font-size: 13.234px;
  font-weight: 600;
  line-height: 16px;
}
[dir] .card-body {
  padding: 14px;
}
.text-modal {
  color: var(--text-black-color);
  font-size: 13.234px;
  font-weight: 600;
  line-height: 25px;
}
.minimum-deposit-amount {
  display: flex;
  justify-content: flex-end;
  color: var(--text-black-color);
  font-weight: 600;
}
.Send {
  color: var(--text-black-color);
  font-weight: bold;
}
[dir] .Send {
  margin: 15px 0px 15px 0px;
}
.minimum-withdrawal-text {
  font-weight: bold;
  color: #686e7d;
}
.placeholder-below-text {
  color: var(--text-black-color);
  font-size: 11.23px;
  font-weight: 600;
  line-height: 20px;
}
.receiving-platform {
  color: var(--text-black-color);
  font-size: 11.23px;
  font-weight: 400;
}
[dir] .pad-l-r-15 {
  padding: 0 15px;
}

[dir] .table.b-table > thead > tr > th, [dir] .table.b-table > tfoot > tr > td {
  background-image: none !important;
}
[dir] .svg-updown {
  margin-bottom: 2px !important;
}
.tr-cal {
  overflow: auto;
}
</style>
